import React from "react";

interface Props {
    name?: string;
}
const WrapperButtonInput = props => {
  return <div className={props.name}><label style={{visibility:"hidden"}}>helloworld</label> {props.children}</div>;
}
export default WrapperButtonInput;
